import React from 'react';

import { useQuery } from '@apollo/client/react';
import { Button } from '@opendoor/bricks/core';
import { IAddressInputAddress } from '@opendoor/cinderblocks/growth/AddressInput/AddressInput';

import { publicClient } from '../config/apolloClients';
import { GetReferralDashboardData_organization } from '../graphql/queries/__generated__/GetReferralDashboardData';
import {
  GET_PRODUCT_ELIGIBILITY,
  IGetProductEligibility,
  IGetProductEligibilityVariables,
} from '../graphql/queries/GetProductEligibility';
import trackEvent from '../helpers/trackEvent';

interface IAddressProps {
  address?: IAddressInputAddress;
  organization: GetReferralDashboardData_organization;
}

const RequestOffer: React.FC<IAddressProps> = ({ address, organization }) => {
  const { data, loading } = useQuery<IGetProductEligibility, IGetProductEligibilityVariables>(
    GET_PRODUCT_ELIGIBILITY,
    {
      skip: !address,
      variables: {
        addressInput: {
          street1: address ? address.street1 : '',
          city: address ? address.city : '',
          state: address ? address.state : '',
          postalCode: address ? address.postal_code : '',
        },
      },
      client: publicClient,
    },
  );

  if (loading) {
    return <span />;
  }

  if (data && data.address.products.homeSell[0].isEligible) {
    const openReferralLink = (referralUrl: any): (() => void) => {
      const referral = data.address.products.homeSell[0].referral
        ? `${data.address.products.homeSell[0].referral.url}&source=7`
        : referralUrl;
      trackEvent('click', 'request-offer', {
        address,
        referral,
        partnershipType: organization.partnershipType,
      });

      return () => window.open(referral);
    };
    return (
      <Button
        /** @ts-expect-error TODO @growth Remove border radius override */
        borderRadius="rounded"
        size="md"
        onClick={openReferralLink(organization.referralUrl)}
        aria-label=""
        analyticsName="partnership-dashboard-request-offer"
      >
        Request Offer
      </Button>
    );
  }

  return <span />;
};

export default RequestOffer;
